/*
 * 创建新智能体
 */

import React, { useRef, useEffect, useState } from 'react';
import { SVGPureIcon } from '@ui/svg-icon';
import { observer } from 'mobx-react-lite';
import { Alert, Form, Input, Row, Col, Tag, Select, Button } from 'antd';
import Upload from './upload-qiniu';
import { HelperCore, HelpOther } from '@/common/helper';
import store from './store';
import knowledgeChoiceStore from '@/components/knowledge-choice/store';
import Conf from '@/common/conf';
import useVisibilityChange from './useVisibilityChange';
import Checkbox from './checkbox';
import Radio from './radio';
// import './index.scss';
import client from '@/store/client';

const { TextArea } = Input;

function CreateWcpComp({ id, onClose = evt => {}, onSucc = evt => {} }) {
  const [form] = Form.useForm();
  const watcherServerlist = Form.useWatch('server_list', form);
  const watchertitle = Form.useWatch('title', form);
  const watcherGreeting = Form.useWatch('greeting', form);
  const watcherDatasetId = Form.useWatch('dataset_id', form);
  const watcherRoleId = Form.useWatch('role_id', form);
  const [openSkill, setOpenSkill] = useState(false);
  const [openKnowledge, setOpenKnowledge] = useState(false);
  const [openModel, setOpenModel] = useState(false);
  const [visibility] = useVisibilityChange();
  const $skllPanel = useRef(null);
  const $modalRef = useRef(null);
  const { greeting, icon, fields } = store;
  const [showPanelSize, setShowPanelSize] = useState('small');

  // 编辑
  useEffect(() => {
    id &&
      store.getMcpDetail(id).then(data => {
        if (data) {
          let {
            greeting,
            server_list,
            dataset_id,
            saylist_detail,
            title,
            intro,
            role_id,
          } = data;

          if (!saylist_detail?.length) {
            saylist_detail = [' '];
          }
          if (server_list?.length) {
            server_list = server_list.map(item => item.server_id);
          }
          form.setFieldsValue({
            greeting,
            server_list,
            dataset_id,
            saylist_detail,
            title,
            intro,
            role_id,
          });
        }
      });
    return () => {
      store.resetForm();
      form.setFieldsValue({});
    };
  }, [id]);

  useEffect(() => {
    form.setFieldValue('saylist_detail', [' ']);
    store.loadMCPlist();
    // 获取面板高度
    const height = $modalRef.current?.clientHeight;

    if (height >= 784) {
      setShowPanelSize('large');
    } else {
      setShowPanelSize('small');
    }
  }, []);

  // 同步ai生成内容
  useEffect(() => {
    if (watchertitle) {
      store.setDisableGened(false);
    } else {
      store.setDisableGened(true);
    }

    if (!watcherGreeting && greeting) {
      form.setFieldsValue({
        greeting,
      });
    }
    if (icon && !store.agentImage) {
      store.setAgentImage(icon);
    }
  }, [greeting, icon, watchertitle, watcherGreeting]);

  useEffect(() => {
    store.loadMCPlist();
  }, [visibility]);

  // 设置默认值
  // useEffect(() => {
  //   if (!id) {
  //     // 创建时根据云控设置默认值
  //     const selectModel = globalStore.cloudConfig.assistantAiagentRoles.find(
  //       item => item.selected == 1
  //     );
  //     console.log(selectModel.auto_generate_id);
  //     if (selectModel.auto_generate_id) {
  //       form.setFieldValue('role_id', selectModel.auto_generate_id);
  //     }
  //   }
  // }, [form, globalStore.cloudConfig?.assistantAiagentRoles, id]);

  // 提交表单时打印选中值
  const onFinish = values => {
    if (!values.title) {
      
      HelpOther.toast('请输入名称');
      return;
    }
    // if (!store.agentImage) {
    //   HelpOther.toast('请上传图片');
    //   return;
    // }
    // if (!values.greeting) {
    //   HelpOther.toast('请输入欢迎语');
    //   return;
    // }

    // if (!(values.saylist_detail && values.saylist_detail.length)) {
    //   HelpOther.toast('请输入试着问问我');
    //   return;
    // }
    if (values.saylist_detail && values.saylist_detail.length) {
      values.saylist_detail = values.saylist_detail
        .map(item => {
          return item?.trim();
        })
        .filter(item => !!item);
    }

    // if (!values?.saylist_detail?.length) {
    //   delete values?.saylist_detail
    // }

    if (values.server_list && values.server_list.length) {
      values.server_list = values.server_list.map(id => {
        const item = store.getCurrentMcp(id);
        return {
          server_id: id,
          server_name: item.server_name,
          display_name: item.display_name,
          is_local: item.is_local,
        };
      });
    } else {
      values.role_id = Conf.roleIds.deepseek
    }

    if (id) {
      values.id = id;
    }

    store.createMcp({
      ...values,

      icon: store.agentImage,
    });
  };
  return (
    <div
      ref={$modalRef}
      className="w-648px pt-30px pb-20px  bg-[#fff] rounded-24px box-border flex flex-col dynamic-height "
    >
      <div className="text-24px font-medium leading-34px mb-12px text-[#000] px-24px">
        {id ? '编辑' : '创建'}AI智能体
      </div>

      <div className="flex-1 overflow-y-auto px-24px nw-scrollbar-x-thin  pt-12px">
        <Form
          onFinish={onFinish}
          form={form}
          name="trigger"
          layout="vertical"
          autoComplete="off"
        >
          <div className="flex items-center mb-20px">
            {store.genLoading ? (
              <div className="w-60px flex items-center justify-center h-60px rounded-200px bg-[rgba(0,0,0,.05)]  mx-auto relative cursor-pointer !mr-16px">
                <div className="rotate-ele">
                  <img
                    src="https://p1.ssl.qhimg.com/d/inn/8ea475776b25/nm_ag_icon_loading.png"
                    className="size-16px"
                    alt=""
                  />
                </div>
              </div>
            ) : (
              <Upload
                onUpload={({ error, url, file }) => {
                  if (error) {
                    return;
                  }
                  store.setAgentImage(url);
                }}
                className="!mx-auto !block w-60px h-60px  !mr-16px"
              >
                <div className="w-60px flex items-center justify-center h-60px rounded-200px bg-[rgba(0,0,0,.05)]  mx-auto relative cursor-pointer">
                  {store.agentImage ? (
                    <img
                      className="size-full object-cover rounded-full overflow-hidden"
                      src={store.agentImage}
                    />
                  ) : (
                    <img
                      onMouseLeave={() => {
                        store.setDefaultImage(store.defaultImage);
                      }}
                      onMouseEnter={() => {
                        store.setDefaultImage(store.defaultHoverImage);
                      }}
                      className="size-full object-cover rounded-full overflow-hidden"
                      src={store.currentImage}
                    />
                    // <SVGPureIcon name="agent" size={36} />
                  )}

                  {/* <div className="absolute bottom-0px right-0px w-36px h-36px flex items-center rounded-200px justify-center bg-[#000]">
                  <SVGPureIcon
                    name="camera"
                    className="text-[#fff]"
                    size={20}
                  />
                </div> */}
                </div>
              </Upload>
            )}

            <Form.Item
              className="flex-1 disable-input !mb-0 title"
              name="title"
            >
              <Input
                disabled={store.genLoading}
                style={{ height: 40 }}
                className="!text-14px"
                size="large"
                placeholder="输入智能体名称"
              />
            </Form.Item>
          </div>
          <div
            onClick={() => {
              const title = form.getFieldValue('title');
              if (!title) {
                HelpOther.toast('请输入智能体名称！');
                return;
              }
              if (store.genLoading || store.disableGened) {
                return;
              }
              if (store.genCount >= 1) {
                HelpOther.confirm({
                  title: '确认删除历史记录?',
                  okText: '自动生成',
                  content: (
                    <div className="whitespace-nowrap">
                      头像、欢迎语将会被生成的内容覆盖，且无法撤销
                    </div>
                  ),
                  onOk: () => {
                    store.genFormContent(title);
                  },
                });
                return;
              }
              store.genFormContent(title);
            }}
            style={{
              opacity: store.genLoading || store.disableGened ? '0.5' : '1',
              background:
                'linear-gradient(90deg, rgba(31, 188, 248, 0.08) 30.1%, rgba(0, 106, 255, 0.08) 100%)',
              // backgroundClip: 'text',
              // WebkitTextFillColor: 'transparent'
            }}
            className="items-center inline-flex px-12px py-4px text-14px font-medium rounded-14px mb-20px ai-generator"
          >
            <img
              className="w-20px mr-6px"
              src="https://p1.ssl.qhimg.com/t110b9a9301dd287ed33d1e2483.png"
            />
            <span
              style={{
                background:
                  'linear-gradient(90deg, #26D0F6 -39.29%, #006AFF 100%)',
                backgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}
            >
              {store.genLoading ? '生成中...' : '一键完善'}
            </span>
          </div>
          <Form.Item className="disable-input" label="欢迎语" name="greeting">
            <Input
              style={{ height: 40 }}
              className="!text-14px "
              size="large"
              disabled={store.genLoading}
              placeholder={
                store.genLoading
                  ? '正在生成中...'
                  : '介绍智能体的功能，将会展示给智能体的用户。'
              }
            />
          </Form.Item>

          <Form.List
            name="saylist_detail"
            rules={[
              {
                validator: async (_, names) => {
                  // if (!names || names.length < 2) {
                  //   return Promise.reject(new Error('At least 2 passengers'));
                  // }
                },
              },
            ]}
          >
            {(fields, { add, remove }, { errors }) => (
              <>
                {fields?.map((field, index) => {
                  return (
                    <Form.Item
                      required={false}
                      key={field.key}
                      name={field.name}
                      label={
                        index == 0 ? (
                          <div className="flex items-center add-item justify-between text-14px">
                            <div>试着问问我</div>

                            <div
                              className="text-[#006aff] hover:text-[#005ee3]"
                              onClick={() => {
                                if (fields.length >= 4) {
                                  return;
                                }
                                add();
                              }}
                            >
                              添加问题
                            </div>
                          </div>
                        ) : (
                          ''
                        )
                      }
                      className={`${index == fields.length - 1 ? 'dynamic-ask-mb' : ''} relative dynamic-ask-item`}
                    >
                      <Input
                        size="large"
                        className="!text-14px"
                        style={{ height: 40 }}
                        suffix={
                          <span className="w-28px h-28px flex items-center rounded-8px justify-center block hover:bg-[rgba(0,0,0,0.06)]">
                            <SVGPureIcon
                              onClick={e => {
                                e.stopPropagation();
                                e.preventDefault();
                                if (fields.length <= 1) {
                                  return;
                                }
                                remove(field.name);
                              }}
                              name="modal_close"
                              size={14}
                              className="text-primary-opacity text-opacity-50 hover:text-opacity-100"
                            />
                          </span>
                        }
                        allowClear={false}
                        placeholder=""
                      />
                    </Form.Item>
                  );
                })}
                {/* <Form.Item>
                <Form.ErrorList errors={errors} />
              </Form.Item> */}
              </>
            )}
          </Form.List>
          <Form.Item label="角色介绍(prompt)" name="intro">
            <TextArea
              className="text-14px nw-no-scroll"
              autoSize={{ minRows: 4, maxRows: 10 }}
              style={{ padding: '10px 12px' }}
              // style={{ height: '80px', resize: 'none', padding: '10px 12px' }}
              placeholder="示例：你是一位经验丰富的研究员，善于在各个领域搜索数据，解读报告，并提供研究成果。"
            />
          </Form.Item>
          <Form.Item
            className="relative position-dropdown"
            label={
              <div className="!text-14px font-medium text-[#000] !leading-20px">
                <div>
                  技能选择
                  {watcherServerlist?.length ? (
                    <span className="text-12px font-normal text-[rgba(0,0,0,0.5)]">
                      (已选{watcherServerlist?.length})
                    </span>
                  ) : null}
                </div>
              </div>
            }
            name="server_list"
          >
            <Select
              size="large"
              className="custom-select custom-skill-select !text-14px"
              mode="multiple"
              open={openSkill}
              placement="topLeft"
              maxTagCount="responsive"
              placeholder="给智能体选择技能"
              style={{
                boxShadow: 'none',
              }}
              onDropdownVisibleChange={visible => setOpenSkill(visible)}
              getPopupContainer={() =>
                document.querySelector('.position-dropdown')
              }
              suffixIcon={
                <SVGPureIcon
                  style={{
                    PointerEvent: 'none',
                    transform: openSkill ? 'rotate(180deg)' : 'rotate(0deg)',
                  }}
                  name="ic_more"
                  className="w-12px h-8px text-[rgba(0,0,0,0.5)]"
                />
              }
              options={store.mcpList}
              tagRender={props => {
                const { label, value, closable, onClose } = props;

                // const onPreventMouseDown = event => {
                //   event.preventDefault();
                //   event.stopPropagation();
                // };
                return (
                  <span className="flex items-center justify-center h-20px ml-12px  ">
                    <span className="text-14px font-normal text-[#000] mr-4px">
                      {label}
                    </span>
                    <span
                      onClick={onClose}
                      className="flex cursor-pointer items-center justify-center w-14px h-14px rounded-100px bg-[rgba(0,0,0,0.1)]"
                    >
                      <SVGPureIcon
                        className="!text-[rgba(0,0,0,0.5)]"
                        name="modal_close "
                        size={8}
                      ></SVGPureIcon>
                    </span>
                  </span>
                );
              }}
              dropdownRender={menu => (
                <div ref={$skllPanel} className="custom-dropdown-content">
                  {/* 下拉菜单顶部可添加搜索或其他操作 */}
                  <div className="px-12px pt-14px pb-8px">
                    <div className="flex items-center justify-between pb-13px border-[rgba(0,0,0,0.06)] border-b-1px">
                      <div className="font-14px text-[#000] font-medium">
                        技能选择
                      </div>
                      <div className="font-14px text-[#006aff] cursor-pointer font-medium flex items-center">
                        <div
                          onClick={() => {
                            // const container = document.getElementById(
                            //   'nworld-app-wcp-modal-container'
                            // );
                            // if (container) {
                            //   container.style.display = 'none';
                            // }
                            client.openPage(
                              client.is360se ? 'https://browser.360.cn/ai/mcpsquare-se.html' : 'https://browser.360.cn/ai/mcpsquare.html'
                            );
                            // agentPageStore.setShowPlayGround(true);
                            // onClose();
                          }}
                        >
                          MCP 工具箱
                        </div>
                        <SVGPureIcon
                          className="text-[#006aff]"
                          size={18}
                          name="arrows_right4"
                        />
                      </div>
                    </div>
                  </div>
                  {/* 渲染每个选项的 Checkbox */}
                  <div
                    className={`nw-scrollbar flex flex-wrap ${showPanelSize == 'large' ? 'max-h-308px' : 'max-h-176px'}`}
                    style={{ overflowY: 'auto' }}
                  >
                    {store.mcpList?.map(item => (
                      <div
                        key={item.value}
                        style={{ padding: '8px 10px', flex: '1 1 50%' }}
                        // onClick={e => e.stopPropagation()} // 阻止点击事件冒泡到 Select
                        className="custom-select-wrapper h-44px box-border hover:bg-[rgba(0,0,0,0.03)] hover:rounded-8px"
                      >
                        <Checkbox
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                          }}
                          value={item.value}
                          server_list={watcherServerlist}
                          className="custom-checkbox-label"
                          checked={form
                            .getFieldValue('server_list')
                            ?.includes(item.value)}
                          onClick={e => {
                            const selectedValues =
                              form.getFieldValue('server_list') || [];
                            if (selectedValues.includes(item.value)) {
                              form.setFieldsValue({
                                server_list: selectedValues.filter(
                                  v => v !== item.value
                                ),
                              });
                            } else {
                              form.setFieldsValue({
                                server_list: [...selectedValues, item.value],
                              });
                            }
                          }}
                        >
                          <img
                            className="w-24px rounded-100px mr-6px"
                            src={item.icon}
                          />
                          <span className="text-14px font-normal">
                            {item.label}
                          </span>
                        </Checkbox>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            ></Select>
          </Form.Item>
          <Form.Item
            className="relative position-dropdown-knowledge"
            label={
              <div className="!text-14px font-medium text-[#000] !leading-20px">
                <div>
                  知识库选择
                  {/* <span className="text-12px font-normal text-[rgba(0,0,0,0.5)]">
                    (非必填)
                  </span> */}
                </div>
              </div>
            }
            name="dataset_id"
          >
            <Select
              className="!text-14px custom-select"
              placement="topLeft"
              onDropdownVisibleChange={visible => setOpenKnowledge(visible)}
              open={openKnowledge}
              suffixIcon={
                <SVGPureIcon
                  style={{
                    PointerEvent: 'none',
                    transform: openKnowledge
                      ? 'rotate(180deg)'
                      : 'rotate(0deg)',
                  }}
                  name="ic_more"
                  className="w-12px h-8px !text-[rgba(0,0,0,0.5)]"
                />
              }
              getPopupContainer={() =>
                document.querySelector('.position-dropdown-knowledge')
              }
              options={knowledgeChoiceStore.list_create.map(item => {
                return {
                  ...item,
                  label: item.name,
                  value: item.folder_id,
                };
              })}
              tagRender={props => {
                const { label, value, closable, onClose } = props;
                return (
                  <span key={value} className="text-14px text-[#000]">
                    label
                  </span>
                );
              }}
              size="large"
              placeholder="给智能体配置知识库"
              dropdownRender={menu => (
                <div className="">
                  {/* 下拉菜单顶部可添加搜索或其他操作 */}
                  <div className="px-12px pt-14px pb-8px">
                    <div className="flex items-center justify-between pb-13px border-[rgba(0,0,0,0.06)] border-b-1px">
                      <div className="font-14px text-[#000] font-medium">
                        知识库选择
                      </div>
                    </div>
                  </div>
                  {/* 渲染每个选项的 Checkbox */}
                  <div
                    className={`nw-scrollbar  ${showPanelSize == 'large' ? 'max-h-308px' : 'max-h-176px'}`}
                    style={{ overflowY: 'auto' }}
                  >
                    {knowledgeChoiceStore.list_create?.map(item => (
                      <div
                        key={item.folder_id}
                        style={{ padding: '0px 8px', flex: '1 1 50%' }}
                        onClick={e => e.stopPropagation()} // 阻止点击事件冒泡到 Select
                        className="custom-select-wrapper h-44px flex items-center box-border hover:bg-[rgba(0,0,0,0.03)] hover:rounded-8px"
                      >
                        <Radio
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                          }}
                          value={item.folder_id}
                          className="custom-checkbox-label"
                          currentValue={watcherDatasetId}
                          onClick={e => {
                            const selectedValue =
                              form.getFieldValue('dataset_id') || '';
                            if (selectedValue != item.value) {
                              form.setFieldsValue({
                                dataset_id: item.folder_id,
                              });
                            } else {
                              form.setFieldsValue({
                                dataset_id: '',
                              });
                            }
                            setOpenKnowledge(false);
                          }}
                        >
                          <span className="text-14px font-normal">
                            {item.name}
                          </span>
                        </Radio>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            />
          </Form.Item>
        </Form>
      </div>
      <Form.Item
        className="btn-item"
        style={{
          display: 'flex',
          justifyContent: 'end',
          marginBottom: '0px !important',
          paddingRight: '24px',
        }}
        label={null}
      >
        <Button
          onClick={() => {
            form.submit();
          }}
          loading={store.sunmitLoading}
          className="wcp-btn"
          type="primary"
          htmlType="submit"
        >
          保存AI智能体
        </Button>
      </Form.Item>
    </div>
  );
}

export default observer(CreateWcpComp);
